import { Button, Form, Input, Modal } from "antd";
import React from "react";

function HardDeleteModal(props) {
  const [form] = Form.useForm();

  function onFinish(values) {
    if (values.delete === "delete") {
      props.handleOk();
      props.handleCancel();
      form.resetFields();
    } else {
      form.setFields([
        {
          name: "delete",
          errors: ["Type 'delete'"],
        },
      ]);
    }
  }

  return (
    <Modal
      title={props.title}
      visible={props.visible}
      onCancel={props.handleCancel}
      footer={null}
      destroyOnClose={true}
    >
      <div className="mb-2">{props.text}</div>
      <Form
        name="hardDelete"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
        form={form}
      >
        <Form.Item
          label="Type 'delete' to confirm"
          name="delete"
          rules={[
            {
              required: true,
              message: "Type 'delete'",
            },
          ]}
        >
          <Input placeholder="delete" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-20" onClick={props.handleCancel}>
              No
            </Button>
            <Button className="w-20" type="primary" htmlType={"submit"}>
              Yes
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default HardDeleteModal;
